module.exports = {"id":"183277","name":"Eden Hazard","rating":"91","photo":"./data/images/photos/3/183277.png","club":{"name":"Chelsea","logo":"./data/images/clubs/Chelsea.png"},"positions":["AG","ATT"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EdenHazard0.json
// module id = 1162
// module chunks = 0